'use client'

/* eslint-disable no-console */
import { useEffect } from 'react'
import { sendEnterpriseEvent } from '@utils/enterpriseSegmentEvent'
import { TAP_EVENT, EVENT_TYPE } from '@constants/enterpriseSegmentData'

const TARGET_FORM_ID = 'd5018fa1-ed08-4739-9390-20d27da5d840'

declare global {
  interface Window {
    HubSpotFormsV4: {
      getForms: () => Array<{
        getFormFieldValues: () => Promise<Record<string, any>>
      }>
      getFormFromEvent: (event: any) => {
        getFormFieldValues: () => Promise<Record<string, any>>
      }
    }
  }
}

// Transform HubSpot form values to flat key-value pairs with gmc_lead_ prefix
const transformFormValues = (values: Record<string, any>): Record<string, any> => {
  const transformedData: Record<string, any> = {}

  Object.keys(values).forEach(key => {
    const field = values[key]
    if (field && typeof field === 'object' && 'name' in field && 'value' in field) {
      // Extract field name (remove "0-1/" prefix)
      const fieldName = field.name.split('/').pop() || field.name
      // Add with gmc_lead_ prefix
      transformedData[`gmc_lead_${fieldName}`] = field.value
    }
  })

  return transformedData
}

const EnterpriseFormTracker = () => {
  useEffect(() => {
    const handleFormSubmission = async (event: any) => {
      const formId = event?.detail?.formId

      if (formId !== TARGET_FORM_ID) {
        return
      }

      // Check if HubSpot library is loaded
      if (!window.HubSpotFormsV4?.getFormFromEvent) {
        return
      }

      try {
        // Use HubSpot API to get form field values
        const form = window.HubSpotFormsV4.getFormFromEvent(event)
        const values = await form.getFormFieldValues()

        // Transform form values
        const transformedData = transformFormValues(values)

        const payload = {
          ...transformedData,
          form_id: formId,
          action_name: 'lead_form_submitted',
          action_type: TAP_EVENT.SUBMIT_LEAD_FORM,
        }

        void sendEnterpriseEvent(payload, EVENT_TYPE.ACTION)
      } catch (error) {}
    }

    const wrappedHandler = (event: any) => {
      void handleFormSubmission(event)
    }

    window.addEventListener('hs-form-event:on-submission:success', wrappedHandler)

    return () => {
      window.removeEventListener('hs-form-event:on-submission:success', wrappedHandler)
    }
  }, [])

  return null
}

export default EnterpriseFormTracker
